import LoginPage from "views/Login/LoginPage";
import PdfTextReplacerPage from "views/PdfTextReplacer/PdfTextReplacerPage";
import { FaFileInvoiceDollar, FaTruckLoading } from "react-icons/fa";
import { IoIosLogIn } from "react-icons/io";
import { FaFilePdf } from "react-icons/fa6";
const routes = [
  {
    name: "Login",
    path: "/login",
    layout: "/auth",
    element: <LoginPage />
  },
  {
    name: "PDF Text Replacer",
    path: "/pdf-text-replacer",
    layout: "/main",
    element: <PdfTextReplacerPage />
  }
];

export default routes;